var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPurpleCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.5505,
  cy: 12.6584,
  r: 10.946,
  stroke: "#7061d4",
  strokeWidth: 2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPurpleCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/purple-circle.11957b64d8166cc29eda9a9c1acdbb38.svg";